import styled from '@emotion/styled';

import Skeleton from 'design-system/Skeleton';
import { blockingColors } from 'design-system/tokens';

export const Container = styled.div``;

export const PreviewData = styled.div`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  @media (min-width: 769px) {
    padding: 16px 20px;
    gap: 16px;
    margin-bottom: 12px;
    box-shadow: none;
  }
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
`;

export const BaseWrap = styled.div`
  width: 100%;

  @media (min-width: 769px) {
    flex: 1;
    max-width: 320px;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: #575757;

  span {
    color: #ff2929;
  }
`;

export const SelectWrap = styled.div`
  select {
    height: 38px;
    padding: 0 34px 0 16px;
    border-radius: 999px;
    border: 1px solid #262626;
    background-color: #fff;
    font-size: 14px;
    font-weight: 500;
    color: #262626;
  }

  select:invalid,
  select option[value=''] {
    color: #8c8c8c;
  }
`;

export const ForecastWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  @media (min-width: 769px) {
    width: auto;
    flex-shrink: 0;
  }
`;

export const Divider = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block;
    width: 100%;
    border-top: 1px dashed rgba(0, 0, 0, 0.12);
  }
`;

export const AlertMessage = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: #575757;

  strong {
    font-weight: 700;
    color: #575757;
  }

  u {
    text-underline-offset: 2px;
  }
`;

export const BlockedCta = styled.button`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  align-self: flex-start;
  width: 256px;
  min-width: 88px;
  max-width: 256px;
  height: 36px;
  padding: 8px 12px;
  border: 1px solid ${blockingColors.actionBlue};
  border-radius: 1000px;
  background: transparent;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: ${blockingColors.actionBlue};
  cursor: pointer;

  @media (max-width: 768px) {
    align-self: center;
  }
`;

export const ForecastSkeleton = styled(Skeleton)`
  width: 100%;

  @media (min-width: 769px) {
    width: 343px;
  }
`;

export const ForecastChip = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: none;
  flex-grow: 0;
  padding: 8px 12px;
  background: ${blockingColors.surface};
  border-radius: 8px;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${blockingColors.text};

  strong {
    font-weight: 700;
  }

  width: 100%;
  min-height: 36px;

  @media (min-width: 769px) {
    width: auto;
    min-width: 343px;
    height: 36px;
    min-height: 0;
    white-space: nowrap;
  }
`;
